let inject = [

  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class CategoriesAccordionController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;

    this.status ={
      open:false
    };
  }

  $onInit(){
  }
}

CategoriesAccordionController.$inject = inject;

export default CategoriesAccordionController;





/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/categories-filter/categories-accordion/categories-accordion.controller.js
 **/